var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9673 3C7.25455 3 3.39273 6.66545 3 11.3127H11.4436L10.1345 10.0036C9.87273 9.74182 9.87273 9.28364 10.1345 9.02182C10.3964 8.76 10.8545 8.76 11.1164 9.02182L13.5382 11.4436C13.6036 11.5091 13.6036 11.5745 13.6691 11.7055C13.7345 11.7709 13.7345 11.8364 13.7345 11.9673C13.7345 12.0982 13.6691 12.1636 13.6691 12.2945C13.6036 12.36 13.6036 12.4909 13.5382 12.5564L11.1164 14.9782C10.8545 15.24 10.3964 15.24 10.1345 14.9782C9.87273 14.7164 9.87273 14.2582 10.1345 13.9964L11.4436 12.6873H3C3.32727 17.3345 7.18909 21 11.9673 21C16.9418 21 20.9345 17.0073 20.9345 12.0327C20.9345 7.05818 16.8764 3 11.9673 3ZM17.5309 14.7818C17.5309 15.1745 17.2036 15.5018 16.8109 15.5018C16.4182 15.5018 16.0909 15.1745 16.0909 14.7818V9.21818C16.0909 8.82545 16.4182 8.49818 16.8109 8.49818C17.2036 8.49818 17.5309 8.82545 17.5309 9.21818V14.7818Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.2e1d1f366f261016cabc85a1a9276daf.svg";
export { ForwardRef as ReactComponent };